function StVincentAndTheGrenadines({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2214)">
  <path d="M23.6522 1.94544C21.379 0.705188 18.7719 0 16 0C13.2282 0 10.621 0.705188 8.34785 1.94544L6.95654 16L8.34785 30.0546C10.621 31.2948 13.2282 32 16 32C18.7719 32 21.379 31.2948 23.6522 30.0546L25.0435 16L23.6522 1.94544Z" fill="#FFDA44"/>
  <path d="M8.34781 30.0544V1.94531C3.37431 4.65906 0 9.93525 0 15.9999C0 22.0646 3.37431 27.3408 8.34781 30.0544Z" fill="#338AF3"/>
  <path d="M31.9999 15.9999C31.9999 9.93525 28.6256 4.65906 23.6521 1.94531V30.0544C28.6256 27.3408 31.9999 22.0646 31.9999 15.9999Z" fill="#6DA544"/>
  <path d="M12.5217 20.1741L9.73901 16.0001L12.5216 11.8262L15.3044 16.0001L12.5217 20.1741Z" fill="#6DA544"/>
  <path d="M19.4782 20.1741L16.6956 16.0001L19.4782 11.8262L22.2608 16.0001L19.4782 20.1741Z" fill="#6DA544"/>
  <path d="M15.9999 25.7394L13.2173 21.5655L15.9999 17.3916L18.7825 21.5655L15.9999 25.7394Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default StVincentAndTheGrenadines;
